// src/App.js
import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import LandingPage from './pages/landing/LandingPage';
import ExercisePage from './pages/exercise/ExercisePage';
import { useGLTF } from '@react-three/drei';


function App() {
  // Set Draco decoder path once when app mounts
  useEffect(() => {
    useGLTF.setDecoderPath('/draco/');
  }, []);

  return (
    <div className="App">
      <Router>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/exercise" element={<ExercisePage />} />
        </Routes>
      </Router>
    </div>
  );
}


export default App;
